import { Component } from '@angular/core';
import { SkeletonComponent } from '@dss-libs/shared/ui/common-components';

@Component({
  selector: 'juno-libs-ui-api-settings-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './api-settings-skeleton.component.html',
})
export class ApiSettingsSkeletonComponent {}
